module.exports = __webpack_public_path__ + "img/applySharer_bind.3aa174f8.png";